import { render, staticRenderFns } from "./Presentes.vue?vue&type=template&id=eb95473e&scoped=true&"
import script from "./Presentes.vue?vue&type=script&lang=js&"
export * from "./Presentes.vue?vue&type=script&lang=js&"
import style0 from "./Presentes.vue?vue&type=style&index=0&id=eb95473e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb95473e",
  null
  
)

export default component.exports